import { Route, Routes } from 'react-router';

import { AppLayout } from 'layouts/AppLayout';

import { DocumentShow } from 'features/documents';

const Router = () => (
  <Routes>
    <Route element={<AppLayout />}>
      <Route path=":id" element={<DocumentShow />} />
    </Route>
  </Routes>
);

export default Router;
